import React from "react";
import { Text, ButtonVariant, Button, Divider, Card } from "@merge-api/merge-javascript-shared";
import { CheckCircle2 } from "lucide-react";

type PlanCardProps = {
  title: string;
  description: string;
  features: string[];
  buttonText: string;
  onClick: () => void;
};

const PlanCard = ({ title, description, features, buttonText, onClick }: PlanCardProps) => {
  return (
    <Card className="flex flex-col p-5">
      <div className="text-center">
        <Text variant="h3">{title}</Text>
        <Text className="text-gray-40">{description}</Text>
        <Divider className="my-6" />
        <ul className="text-left list-none p-0">
          {features.map((feature, index) => (
            <li key={index} className="flex mb-4">
              <CheckCircle2 size={16} className="mr-2 flex-shrink-0 mt-1" />
              <Text className="flex-grow">{feature}</Text>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-auto pt-10">
        <Button variant={ButtonVariant.SecondaryGray} fullWidth onClick={onClick}>
          {buttonText}
        </Button>
      </div>
    </Card>
  );
};

export default PlanCard;
